import { render } from "./Cgu.vue?vue&type=template&id=32f7f42c&scoped=true"
const script = {}

import "./Cgu.vue?vue&type=style&index=0&id=32f7f42c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f7f42c"]])

export default __exports__